<div class="nav-menu--container">
  <div class="nav-menu--list d-none d-sm-none d-md-none d-lg-flex d-xl-flex">
    <div *ngFor="let item of menuList" (click)="_onSelectMenu(item.key)" class="nav-menu--item {{activeMenu === item.key ? 'active' : ''}}">
      {{item.title}}
    </div>
  </div>
  <div class="nav-menu--dropdown d-block d-sm-block d-md-block d-lg-none d-xl-none">
    <app-dropdown [title]="menuList[activeMenu]?.title" [valueDropdown]="mapToDropdown()" (selected)="_onSelectMenu($event)"></app-dropdown>
  </div>
</div>